<template>
  <span>
    <span v-if="buildVersion" class="text-caption">v{{ buildVersion }}</span>
    <span v-if="showOfflineDevTools">
      <span>
        <v-btn text small @click="onToggleConnectionStatus"
          >Toggle-Online</v-btn
        >
      </span>
      <span>
        <v-btn text small @click="onForceDataSync">DoSync</v-btn>
      </span>
    </span>
  </span>
</template>


<script>

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapState(['userStore', 'voyageReportsStore', 'dataSyncStore']),
    ...mapGetters({
      isUserLoggedIn: 'userStore/isUserLoggedIn',
      isClientConnectedToServer: 'userStore/isClientConnectedToServer',
      getActiveSiteId: 'userStore/getActiveSiteId',
      showOfflineDevTools: 'userStore/showOfflineDevTools',
      buildVersion: 'userStore/buildVersion',
    }),
  },
  methods: {
    onToggleConnectionStatus() {
      const currentState = this.isClientConnectedToServer;
      this.$store.dispatch('userStore/setIsClientConnectedToServer', !currentState);
    },
    onForceDataSync() {
      this.$store.dispatch('dataSyncStore/doDataSyncAndReloadVoyageReports', this.getActiveSiteId);
    },
  },
};
</script>
